import { fetchClient } from '../../Utils/helpers';
import {
  CREATE_ADMIN, GET_ADMIN, GET_ADMIN_DETAILS, UPDATE_ADMIN,
} from '../actionTypes';

export function getAdmin({
  page = 1, limit = 10, sort = 'Newest', keyword = '',
}) {
  return {
    type: GET_ADMIN,
    payload: fetchClient({
      method: 'GET',
      url: `/admin?page=${page}&limit=${limit}&sort=${sort}&keyword=${keyword}`,
    }),
  };
}

export function getAdminDetails(id) {
  return {
    type: GET_ADMIN_DETAILS,
    payload: fetchClient({
      method: 'GET',
      url: `/admin/detail/${id}`,
    }),
  };
}

export function createAdmin(data) {
  return {
    type: CREATE_ADMIN,
    payload: fetchClient({
      method: 'POST',
      url: '/admin',
      data,
    }),
  };
}

export function updateAdmin(data, id) {
  return {
    type: UPDATE_ADMIN,
    payload: fetchClient({
      method: 'PUT',
      url: `/admin/update/${id}`,
      data,
    }),
  };
}
